export default __webpack_public_path__ + "static/media/moderateRainFour.2bb1820f.jpg";